// extracted by mini-css-extract-plugin
export var icon = "_5p-1";
export var subtext = "_5p-0";